function BulletList({ title, items }) {
  if (!items?.length) return null;
  return (
    <div>
      <p className="text-[11px] uppercase tracking-wide text-content-faint">{title}</p>
      <ul className="mt-2 flex flex-col gap-1">
        {items.map((item) => (
          <li key={item} className="flex gap-2 text-sm text-content-secondary">
            <span className="text-content-faint">•</span>
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default BulletList;
